import React, { useEffect, useState } from 'react';
import { scroller } from 'react-scroll';

const hashNavigation = () => {
  const [hash, setHash] = useState('');

  useEffect(() => {
    const { search } = window.location;
    if (search) {
      const query = search.split('=');
      if (query.length > 0) {
        const id = decodeURI(query[1]);
        setHash(id);
      }
    }
  });

  useEffect(() => {
    if (hash) {
      scroller.scrollTo(hash, {
        duration: 600,
        offset: -80,
        delay: 100,
        smooth: true,
      });
    }
  }, [hash]);
};

export { hashNavigation };
